import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';

/**
 * Redirects to the same path without a trailing slash.
 * This middleware is applied globally to all routes.
 * Copied from the link below.
 * @see https://github.com/nuxt/nuxt/issues/15462#issuecomment-1407374859
 */
export default defineNuxtRouteMiddleware((to) => {
	if (to.path !== '/' && to.path.endsWith('/')) {
		const nextPath = to.path.replace(/\/+$/, '') || '/';
		const nextRoute = {
			// Do not spread the old route because it will contain 'name', 'params' and 'fullPath'
			// if the aforementioned are present then middleware collisions can occur on production build, which in turn can cause unexpected behavior like infinite redirects.
			path: nextPath,
			hash: to.hash,
			query: to.query,
			redirectedFrom: to.fullPath,
		};
		return navigateTo(nextRoute, { redirectCode: 301 });
	}
});
